import { Fiesta } from '../../models/fiesta.model';
import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, ToastController, MenuController } from 'ionic-angular';
import { BuscadorPage } from '../buscador/buscador';
import { Consultas } from '../../providers/consultas';
import { FiestaPage } from '../fiesta/fiesta';
import { VariablesGlobales } from '../../providers/variables-globales';

/**
 * Generated class for the FiestasPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-fiestas',
  templateUrl: 'fiestas.html',
  providers: [ Consultas ]
})
export class FiestasPage {
  public nombrePueblo: string;
  public idCiudad: number;
  public loader: any;
  public fiestas: Array<Fiesta>;

  constructor(public navCtrl: NavController, public navParams: NavParams,
     public loadingCtrl: LoadingController, public consultas:Consultas,
     public toastCtrl:ToastController,public menuCtrl:MenuController, public global: VariablesGlobales,) {
    this.idCiudad = this.navParams.get("idCiudad");
    this.nombrePueblo = this.navParams.get("nombrePueblo");
    this.loader = this.loadingCtrl.create();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad FiestasPage');
  }
  goToBuscar(){
    this.navCtrl.push(BuscadorPage);
  }
  goToFiesta(fiesta){
    this.navCtrl.push(FiestaPage,{fiesta: fiesta});
  }
  ngOnInit(){
    this.fiestas = new Array<Fiesta>();
    this.loader = this.loadingCtrl.create();
    //Muestro el cargador mientras se cargan los productos
    this.loader.present().then(()=>{
        this.consultas.getFiestas(this.idCiudad).subscribe(x=>
          {
            if(!x){
              let toast = this.toastCtrl.create({
                  message: 'No hay datos sobre fiestas de este pueblo',
                  duration: 3000,
                  position: 'bottom'
                });

                toast.onDidDismiss(() => {
                  console.log('Dismissed toast');
                });

                toast.present();
                this.navCtrl.pop();
            }
            this.fiestas = x as Array<Fiesta>;
            console.log(this.fiestas);
            this.loader.dismiss();
          },error=>{
            console.log(error);
            this.loader.dismiss();
          }
          );
    });
  }
  toggleMenu() {
    this.menuCtrl.toggle();
  }
}



// WEBPACK FOOTER //
// ./src/pages/fiestas/fiestas.ts